import { useRef } from 'react'
import { type LayoutChangeEvent, ScrollView, type ScrollViewProps } from 'react-native'

type TCenteredScrollViewProps = Omit<ScrollViewProps, 'onContentSizeChange' | 'onLayout' | 'ref'>

export const CenteredScrollView = ({ children, ...props }: TCenteredScrollViewProps) => {
  const scrollViewRef = useRef<ScrollView>(null)
  const scrollViewportHeight = useRef(0)
  const scrollContentHeight = useRef(0)

  const scrollToCenter = () => {
    const offset = (scrollContentHeight.current - scrollViewportHeight.current) / 2
    if (offset > 0) {
      scrollViewRef.current?.scrollTo({ y: offset, animated: false })
    }
  }

  const handleScrollLayout = (e: LayoutChangeEvent) => {
    scrollViewportHeight.current = e.nativeEvent.layout.height
    scrollToCenter()
  }

  const handleContentSizeChange = (_w: number, h: number) => {
    scrollContentHeight.current = h
    scrollToCenter()
  }

  return (
    <ScrollView
      ref={scrollViewRef}
      onLayout={handleScrollLayout}
      onContentSizeChange={handleContentSizeChange}
      {...props}
    >
      {children}
    </ScrollView>
  )
}
